import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';
import * as React from 'react';
import { useCurrentOrganisation } from '../../../../../app/CurrentOrganisationProvider';
import { Card, Loading, Workspace } from '../../../../../design-system';

export const Header: React.FC = () => {
  const { loading, organisation } = useCurrentOrganisation();

  if (loading || !organisation) {
    return (
      <Workspace>
        <Loading />
      </Workspace>
    );
  }

  const { name } = organisation;

  return (
    <Card>
      <Box p={2}>
        <Grid container spacing={2}>
          <Box>
            <Typography variant="h6" style={{ wordBreak: 'break-word' }}>
              {name}
            </Typography>
          </Box>
        </Grid>
      </Box>
    </Card>
  );
};
